<template>
  <div class="user-layout d-flex flex-column min-vh-100">
    <!-- Header -->
    <header class="sticky-top bg-white shadow-sm border-bottom">
      <nav class="navbar navbar-expand-lg navbar-light bg-white container py-2 d-flex align-items-center justify-content-between">
        <router-link to="/" class="navbar-brand fw-bold fs-3 text-primary">
          <i class="bi bi-house-door-fill me-2"></i>guest5of5
        </router-link>
        <button class="navbar-toggler" type="button" @click="mobileMenuOpen = !mobileMenuOpen">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="d-none d-lg-flex justify-content-end flex-grow-1">
          <ul class="navbar-nav align-items-center gap-2 ms-auto">
            <li class="nav-item">
              <router-link to="/" class="nav-link">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/hotels" class="nav-link">Hotels</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/bookings" class="nav-link">My Bookings</router-link>
            </li>
            <li class="nav-item" v-if="isLoggedIn">
              <button class="btn btn-outline-danger btn-sm ms-2" @click="logout">
                <i class="bi bi-box-arrow-right"></i> Logout
              </button>
            </li>
            <li class="nav-item" v-else>
              <router-link to="/login" class="btn btn-outline-primary btn-sm ms-2">Login <i class="bi bi-box-arrow-in-right"></i></router-link>
            </li>
            <li v-if="user" class="nav-item dropdown ms-3">
              <a class="nav-link dropdown-toggle d-flex align-items-center" href="#" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bi bi-person-circle fs-4 me-2"></i>
                <span class="fw-semibold">{{ user.full_name }}</span>
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                <li>
                  <router-link :to="{ name: 'UserProfile' }" class="dropdown-item">
                    View Profile
                  </router-link>
                </li>

              </ul>
            </li>
          </ul>
        </div>
        <!-- Mobile Sidebar -->
        <div v-if="mobileMenuOpen" class="offcanvas offcanvas-start show d-lg-none" tabindex="-1" style="visibility: visible; background: rgba(0,0,0,0.3);">
          <div class="offcanvas-dialog h-100">
            <div class="offcanvas-content bg-white h-100 p-4 position-relative">
              <button type="button" class="btn-close position-absolute top-0 end-0 m-3" aria-label="Close" @click="mobileMenuOpen = false"></button>
              <div v-if="user" class="mb-4">
                <div class="fw-bold fs-5 mb-1"><i class="bi bi-person-circle me-2"></i>{{ user.full_name }}</div>
                <div class="small text-muted">{{ user.email }}</div>
                <div class="small text-muted">{{ user.phone }}</div>
              </div>
              <ul class="nav flex-column gap-2">
                <li class="nav-item">
                  <router-link to="/" class="nav-link" @click.native="mobileMenuOpen = false"><i class="bi bi-house-door me-2"></i>Home</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/hotels" class="nav-link" @click.native="mobileMenuOpen = false"><i class="bi bi-building me-2"></i>Hotels</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/bookings" class="nav-link" @click.native="mobileMenuOpen = false"><i class="bi bi-journal-bookmark me-2"></i>My Bookings</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/profile" class="nav-link" @click.native="mobileMenuOpen = false"><i class="bi bi-person me-2"></i>Profile</router-link>
                </li>
                <li class="nav-item" v-if="isLoggedIn">
                  <button class="btn btn-outline-danger w-100 mt-2" @click="logout"><i class="bi bi-box-arrow-right me-2"></i>Logout</button>
                </li>
                <li class="nav-item ms-3" v-else>
                  <router-link to="/login" class="btn btn-outline-primary btn-sm" @click.native="mobileMenuOpen = false">Login <i class="bi bi-box-arrow-in-right"></i></router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>

    <!-- Main Content -->
    <main class="main-content flex-grow-1 bg-light">
      <router-view />
    </main>

    <!-- Footer -->
    <footer class="footer bg-white py-4 mt-auto border-top">
      <div class="container d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div>&copy; {{ new Date().getFullYear() }} HotelBooker. All rights reserved.</div>
        <div class="d-flex gap-3 mt-2 mt-md-0">
          <router-link to="/about" class="text-decoration-none text-secondary">About</router-link>
          <router-link to="/contact" class="text-decoration-none text-secondary">Contact</router-link>
          <router-link to="/privacy" class="text-decoration-none text-secondary">Privacy Policy</router-link>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { removeStorage } from '@/Util/auth';
import { mapGetters } from 'vuex';

export default {
  name: "UserLayout",
  data() {
    return {
      mobileMenuOpen: false,
    };
  },
  computed: {
    ...mapGetters(['isLoggedIn','user'])
  },
  mounted() {
  },
  methods: {
    logout() {
      removeStorage("auth");
      this.$store.dispatch("user",null);
      if (this.$route.path !== "/") {
        this.$router.push("/");
      } else {
        // If you're already on /, you can reload the page to reset state
        this.$router.go(0);
      }
    },
  },
};
</script>

<!-- Bootstrap CSS and Icons should be included globally in your project for this to work properly -->
<style scoped>
.user-layout {
  background: #f8f9fa;
}
.main-content {
  min-height: 60vh;
}
.offcanvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1050;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.offcanvas-dialog {
  width: 260px;
  height: 100%;
}
.offcanvas-content {
  width: 100%;
  height: 100%;
  border-radius: 0 1rem 1rem 0;
  box-shadow: 0 0 2rem rgba(0,0,0,0.1);
}
@media (min-width: 992px) {
  .offcanvas {
    display: none !important;
  }
}
</style>
